"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _TabContext = _interopRequireDefault(require("@material-ui/lab/TabContext"));
var _TabPanel = _interopRequireDefault(require("@material-ui/lab/TabPanel"));
var _SttPaper = _interopRequireDefault(require("../SttPaper"));
var _SttAlerta = _interopRequireDefault(require("../SttAlerta"));
var _SttTabPanel = _interopRequireDefault(require("../SttTabPanel"));
var _closabeTabLabel = _interopRequireDefault(require("./closabeTabLabel"));
var _editableTabLabel = _interopRequireDefault(require("./editableTabLabel"));
var _excluded = ["conteudo"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    indicator: {
      display: "none"
    },
    label: {
      fontSize: "0.9rem",
      fontWeight: "bold",
      textTransform: "none",
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5)
    }
  };
});
var useStylesTab = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: "400px",
      color: theme.palette.primary.main,
      backgroundColor: "white",
      // border: `1px solid ${theme.palette.primary.main}`,
      "&$selected": {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        "& span": {
          color: "white"
        }
      },
      "& span": {
        color: theme.palette.primary.main
      },
      borderRadius: theme.spacing(2.5),
      marginLeft: theme.spacing(0.5),
      marginBottom: "-12px",
      minWidth: "auto",
      minHeight: theme.spacing(4),
      padding: "4px 8px",
      display: "flex"
    },
    selected: {},
    wrapper: {
      display: "flex",
      alignItems: "center"
    }
  };
});
var useStylesSeparator = (0, _styles.makeStyles)(function (theme) {
  return {
    separator: {
      borderLeft: "1px solid white}",
      alignSelf: "stretch",
      height: "auto"
    }
  };
});
var useStylesTabsContainer = (0, _styles.makeStyles)(function (theme) {
  return {
    gradientLeft: {
      content: '""',
      position: "absolute",
      left: 0,
      width: theme.spacing(2),
      minHeight: 38,
      zIndex: 10,
      background: "linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
      pointerEvents: "none"
    },
    gradientRight: {
      content: '""',
      position: "absolute",
      width: theme.spacing(4),
      right: 0,
      minHeight: 38,
      zIndex: 10,
      background: "linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
      pointerEvents: "none"
    }
  };
});
var TabsMobile = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var abas = props.abas,
    className = props.className,
    abaAtiva = props.abaAtiva,
    handleChangeAbaAtiva = props.handleChangeAbaAtiva,
    _props$canClose = props.canClose,
    canClose = _props$canClose === void 0 ? false : _props$canClose,
    handleCloseTab = props.handleCloseTab,
    _props$canEdit = props.canEdit,
    canEdit = _props$canEdit === void 0 ? false : _props$canEdit,
    _props$exigeConfirmac = props.exigeConfirmacaoClose,
    exigeConfirmacaoClose = _props$exigeConfirmac === void 0 ? true : _props$exigeConfirmac,
    handleEditTab = props.handleEditTab,
    permanente = props.permanente,
    _props$preload = props.preload,
    preload = _props$preload === void 0 ? true : _props$preload;
  var _useState = (0, _react.useState)(abaAtiva || "0"),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    removerAba = _useState4[0],
    setRemoverAba = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    msgRemoverAba = _useState6[0],
    setMsgRemoverAba = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    opcoesRemoverAba = _useState8[0],
    setOpcoesRemoverAba = _useState8[1];
  var classes = useStyles();
  var classesTabV2 = useStylesTab();
  var classesSeparator = useStylesSeparator();
  var classesTabs = useStylesTabsContainer();
  var handleChange = function handleChange(_, newValue) {
    setValue(newValue);
    if (handleChangeAbaAtiva) {
      handleChangeAbaAtiva(newValue);
    }
  };
  (0, _react.useEffect)(function () {
    if (abaAtiva) {
      setValue(abaAtiva);
    }
  }, [abaAtiva]);
  (0, _react.useEffect)(function () {
    if (abas.length === 1 || abas.length == value) {
      setValue("0");
    }
  }, [abas]);
  var preCloseTab = function preCloseTab(titulo, indice) {
    var handleClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var aba = abas[indice];
    if (exigeConfirmacaoClose || aba.exigeConfirmacaoClose) {
      setMsgRemoverAba("Voc\xEA deseja realmente fechar a aba \"".concat(titulo, "\"?"));
      setRemoverAba(true);
      var opcoes = [{
        title: "Sim",
        onClick: function onClick(params) {
          handleCloseTab(params);
          setRemoverAba(false);
          handleClose();
        },
        params: [indice]
      }, {
        title: "Não",
        onClick: function onClick() {
          return setRemoverAba(false);
        }
      }];
      setOpcoesRemoverAba(opcoes);
    } else {
      handleCloseTab([indice]);
      setRemoverAba(false);
    }
  };
  var createLabel = function createLabel(aba, indice, value) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.label
    }, aba.titulo), value == indice && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (canEdit || canClose && !aba.permanente) && /*#__PURE__*/_react["default"].createElement("span", {
      className: classesSeparator.separator
    }), canEdit && /*#__PURE__*/_react["default"].createElement(_editableTabLabel["default"], {
      title: aba.titulo,
      index: indice,
      handleEdit: handleEditTab,
      small: true
    }), canClose && !aba.permanente && /*#__PURE__*/_react["default"].createElement(_closabeTabLabel["default"], {
      title: aba.titulo,
      index: indice,
      handleClose: aba.handleClose,
      preCloseTab: preCloseTab,
      small: true
    })));
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      setValue: setValue,
      handleChange: handleChange
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_SttPaper["default"], {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_TabContext["default"], {
    value: value
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classesTabs.gradientLeft
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classesTabs.gradientRight
  }), /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    onChange: handleChange,
    value: value,
    style: {
      minHeight: 38
    },
    variant: "scrollable",
    scrollButtons: "auto",
    TabIndicatorProps: {
      className: classes.indicator
    }
  }, abas.map(function (aba, indice) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      component: "div",
      key: aba.key || aba.idAba || aba.id || indice,
      classes: classesTabV2,
      disabled: aba.disabled,
      label: createLabel(aba, indice, value),
      disableRipple: true,
      onClick: aba.handleClick || null,
      value: indice.toString()
    });
  })), abas.map(function (aba, indice) {
    var conteudo = aba.conteudo,
      other = _objectWithoutProperties(aba, _excluded);
    if (conteudo === undefined) {
      return null;
    }
    var Conteudo = conteudo;
    var Panel = _TabPanel["default"];
    if (permanente) {
      Panel = _SttTabPanel["default"];
    }
    var panelValue = indice.toString();
    if (indice == value) {
      aba.carregada = true;
    }
    return /*#__PURE__*/_react["default"].createElement(Panel, {
      key: aba.key || aba.idAba || aba.id || indice,
      value: panelValue
    }, preload || aba.carregada ? /*#__PURE__*/_react["default"].createElement(Conteudo, other) : null);
  })), /*#__PURE__*/_react["default"].createElement(_SttAlerta["default"], {
    open: removerAba,
    title: "Aten\xE7\xE3o",
    message: msgRemoverAba,
    type: "alert",
    options: opcoesRemoverAba,
    onClose: function onClose() {
      return setRemoverAba(false);
    }
  }));
});
TabsMobile.propTypes = {
  abas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    titulo: _propTypes["default"].string.isRequired,
    conteudo: _propTypes["default"].elementType.isRequired,
    handleClick: _propTypes["default"].func,
    permanente: _propTypes["default"].bool
  })).isRequired,
  preload: _propTypes["default"].bool,
  canClose: _propTypes["default"].bool,
  permanente: _propTypes["default"].bool
};
var _default = TabsMobile;
exports["default"] = _default;